/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Realico Portal API
 * Portal API
 * OpenAPI spec version: 1.0.0
 */

/**
 * @nullable
 */
export type InquirySellerContactResponseDtoRole = typeof InquirySellerContactResponseDtoRole[keyof typeof InquirySellerContactResponseDtoRole] | null;


export const InquirySellerContactResponseDtoRole = {
  PRIVATE_ADVERTISER: 'PRIVATE_ADVERTISER',
  BROKER: 'BROKER',
  REAL_ESTATE_AGENCY: 'REAL_ESTATE_AGENCY',
  DEVELOPER: 'DEVELOPER',
} as const;
